import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';
import { JtnUiBtn } from '../jtn-ui-btn';
import { JtnUiBtnIcon } from '../jtn-ui-btn-icon';
import { JtnUiTypography } from '../jtn-ui-typography';

import styles from './jtn-ui-error-modal.style.scss?module';

const CLOSE_ICON_SIZE = 18;
const ICON_SIZE = 96;

interface Events {
  onClosed: void;
  onClickedBtn: void;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiErrorModal',
    props: {
      isMobile: {
        type: Boolean,
        default: false
      },
      btnUrl: {
        type: String,
        default: ''
      },
      btnText: {
        type: String,
        default: ''
      },
      btnTheme: {
        type: String,
        default: 'primary'
      },
      message: {
        type: String,
        default: ''
      }
    },
    methods: {
      emitCloseModal() {
        this.$emit('closed');
      },
      emitClickedBtn() {
        this.$emit('clickedBtn');
      }
    },
    render() {
      return (
        <div class={[styles.errorModal, this.isMobile ? styles.mobile : '']}>
          <JtnUiBtnIcon
            class={styles.closeBtn}
            btn-type="button-other-transparent"
            size={CLOSE_ICON_SIZE}
            onClick={() => this.emitCloseModal()}
          >
            <svg width={CLOSE_ICON_SIZE} height={CLOSE_ICON_SIZE}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-close"></use>
            </svg>
          </JtnUiBtnIcon>
          <JtnUiTypography class={styles.header} tag="h3" type="font-modal-title-gray">
            Произошла ошибка
          </JtnUiTypography>

          <div class={styles.content}>
            <svg class={styles.icon} width={ICON_SIZE} height={ICON_SIZE}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-action-result.298c59fd07ca588e2f5a658ed63a7e4b.svg#jtn-action-result-error-result"></use>
            </svg>
            <JtnUiTypography
              class={styles.text}
              domPropsInnerHTML={this.message}
              tag="p"
              type="font-settings-message"
            />

            {this.btnText !== '' && (
              <JtnUiBtn
                class={styles.btn}
                href={this.btnUrl}
                theme={this.btnTheme}
                onClick={() => this.emitClickedBtn()}
              >
                {this.btnText}
              </JtnUiBtn>
            )}
          </div>
        </div>
      );
    }
  });
